module.exports = __webpack_public_path__ + "static/img/7.ab20510e.jpg";